import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { bindActionCreators } from "redux";

import { Company, CompanyValue } from "../../entities";
import { RootState } from "../../state";
import { EntityValidationResultMap } from "../../lib/entities/validation";
import { visibleCompanyValuesSelecor } from "../selectors";
import { draftCompanyValuesUpdated, loadInvisibleCompanyValuesWorker } from "../actions";
import { modalClosed } from "../../common/actions/Modal";
import ValuesSection from "./ValuesSection";
import ModalContainer, { ModalRenderFunc, ModalChildrenFunc } from "../../common/components/modal/ModalContainer";
import CompanyValuesSelectorContainer from "../../company_values/components/CompanyValuesSelectorContainer";

interface MappedProps {
  company: Company;
  editMode: boolean;
  locale: string;
  companyValues: CompanyValue[];
  visibleCompanyValues: CompanyValue[];
  validationErrors: EntityValidationResultMap<CompanyValue>;
}

interface MappedActions {
  draftCompanyValuesUpdated: typeof draftCompanyValuesUpdated;
  loadInvisibleCompanyValuesWorker: typeof loadInvisibleCompanyValuesWorker;
  modalClosed: typeof modalClosed;
}

type Props = MappedProps & MappedActions;

class ValuesSectionContainer extends React.Component<Props> {
  public componentDidMount() {
    const { editMode, company, loadInvisibleCompanyValuesWorker } = this.props;
    if (editMode) {
      loadInvisibleCompanyValuesWorker(company);
    }
  }

  public componentWillReceiveProps(nextProps: Props) {
    if (!this.props.editMode && nextProps.editMode) {
      nextProps.loadInvisibleCompanyValuesWorker(nextProps.company);
    }
  }

  public onChangeVisibleCompanyValues = (visibleCompanyValues: CompanyValue[]) => {
    const { companyValues, draftCompanyValuesUpdated } = this.props;
    draftCompanyValuesUpdated({
      companyValues: companyValues.map(val => {
        const updated = visibleCompanyValues.find(v => v.feature === val.feature);
        return updated || val;
      }),
    });
  };

  public onSubmitCompanyValuesSelector = (companyValues: CompanyValue[]) => {
    const { draftCompanyValuesUpdated, modalClosed } = this.props;
    modalClosed({ name: "company_values/selector" });
    draftCompanyValuesUpdated({ companyValues });
  };

  public onCancelCompanyValuesSelector = () => {
    this.props.modalClosed({ name: "company_values/selector" });
  };

  public render() {
    return (
      <ModalContainer name="company_values/selector" render={this.renderValuesSelector}>
        {this.renderContent}
      </ModalContainer>
    );
  }

  private renderValuesSelector: ModalRenderFunc = () => {
    return (
      <CompanyValuesSelectorContainer
        companyValues={this.props.companyValues}
        onSubmit={this.onSubmitCompanyValuesSelector}
        onCancel={this.onCancelCompanyValuesSelector}
      />
    );
  };

  private renderContent: ModalChildrenFunc = ({ onOpen }) => {
    const { visibleCompanyValues, editMode, locale, validationErrors } = this.props;
    return (
      <ValuesSection
        companyValues={visibleCompanyValues}
        locale={locale}
        editable={editMode}
        validationErrors={validationErrors}
        onStartSelecting={onOpen}
        onChange={this.onChangeVisibleCompanyValues}
      />
    );
  };
}

function mapStateToProps(state: RootState): MappedProps {
  return {
    company: state.companies.common.draftCompany!,
    editMode: state.companies.common.editMode,
    locale: state.auth.locale,
    companyValues: state.companies.show.draftCompanyValues,
    visibleCompanyValues: visibleCompanyValuesSelecor(state),
    validationErrors: state.companies.show.draftCompanyValueErrors,
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>): MappedActions {
  return bindActionCreators(
    {
      draftCompanyValuesUpdated,
      loadInvisibleCompanyValuesWorker,
      modalClosed,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ValuesSectionContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/ValuesSectionContainer.tsx